import { Cell } from "react-table";
import { ContractManageList } from "src/api/contract/contract-types";
import { BaseTooltip } from "src/components";
import { BaseContractStatus } from "src/components/BaseContractStatus";
import BaseNewTabLink from "src/components/BaseNewTabLink";
import ProductTypeChangeLabel from "src/components/ProductTypeChangeLabel";
import { PagePath } from "src/pages/product/details";

export const rvContractColumns: any = [
  {
    // 신청번호/계약번호 대체 컬럼. 계약 ID에 계약상세 링크가 있으므로 계약관리 ID는 링크를 걸지 않는다.
    Header: "계약관리 ID",
    accessor: "contractManageId",
    width: 120,
    Cell: (props: Cell<ContractManageList>) => <div className="w-100">{props.value ? String(props.value) : "-"}</div>,
  },
  {
    Header: "계약 ID",
    accessor: "contractId",
    width: 100,
    Cell: ({ value }: Cell<ContractManageList>) => <BaseNewTabLink path={PagePath.contract.detail.replace(":id", value)} value={value} />,
  },
  {
    Header: "계약상태",
    accessor: "contractStep",
    width: 80,
    Cell: ({ value }: any) => {
      return <BaseContractStatus status={value} />;
    },
  },
  {
    Header: "계약명",
    accessor: "contractName",
    width: 240,
    Cell: ({ value }: Cell<ContractManageList>) => {
      return (
        <div className="w-100">
          <BaseTooltip contents={value || "-"}></BaseTooltip>
        </div>
      );
    },
  },
  {
    Header: "상품명",
    accessor: "spaceProductName",
    width: 200,
    Cell: ({ value }: Cell<ContractManageList>) => {
      return (
        <div className="w-100">
          <BaseTooltip contents={value || "-"}></BaseTooltip>
        </div>
      );
    },
  },
  {
    Header: "상품유형",
    accessor: "spaceProductType",
    width: 80,
    Cell: ({ value }: Cell<ContractManageList>) => {
      return <ProductTypeChangeLabel productType={value} />;
    },
  },
  {
    Header: "계약자(법인명/상호)",
    accessor: "mbOrganizationName",
    width: 190,
    Cell: (props: Cell<ContractManageList>) => (
      <div className="w-100">
        <BaseTooltip contents={props.value ? props.value : "-"}></BaseTooltip>
      </div>
    ),
  },
];
